import type { FC, ReactNode } from "react";
import { motion } from "motion/react";

import { setStyle, chatListStyle } from "./HistorySet.css";
import { Flex } from "../../Flex/Flex";
import { Text } from "../../Text/Text";
import { contentChildMotionVariants } from "../ChatHistoryList.motion";

export const HistorySet: FC<{ title: string; children: ReactNode }> = ({
  title,
  children,
}) => (
  <Flex direction="column" className={setStyle}>
    <motion.div variants={contentChildMotionVariants}>
      <Text variant="surfaceSubtitle" color="currentColor50">
        {title}
      </Text>
    </motion.div>
    <Flex as="ul" direction="column" className={chatListStyle}>
      {children}
    </Flex>
  </Flex>
);
